interface ShouldUseDevProxyRouteOptions {
  isDev: boolean;
  configuredBaseUrl: string;
  currentOrigin: string;
}

function isLocalHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function shouldUseDevProxyRoute({
  isDev,
  configuredBaseUrl,
  currentOrigin,
}: ShouldUseDevProxyRouteOptions): boolean {
  if (!isDev || !configuredBaseUrl) return false;

  try {
    const baseUrl = new URL(configuredBaseUrl);
    const originUrl = new URL(currentOrigin);
    const sameLocalHost =
      baseUrl.hostname === originUrl.hostname ||
      (baseUrl.hostname === '127.0.0.1' && originUrl.hostname === 'localhost') ||
      (baseUrl.hostname === 'localhost' && originUrl.hostname === '127.0.0.1');

    if (sameLocalHost && baseUrl.port !== originUrl.port) {
      return true;
    }

    return isLocalHost(baseUrl.hostname) && !isLocalHost(originUrl.hostname);
  } catch {
    return false;
  }
}
